import { render, staticRenderFns } from "./CreateNewDeliveryLocation.vue?vue&type=template&id=4d66593c&scoped=true"
import script from "./CreateNewDeliveryLocation.vue?vue&type=script&lang=js"
export * from "./CreateNewDeliveryLocation.vue?vue&type=script&lang=js"
import style0 from "./CreateNewDeliveryLocation.vue?vue&type=style&index=0&id=4d66593c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d66593c",
  null
  
)

export default component.exports